import FavoriteRounded from "@mui/icons-material/FavoriteRounded"
import FavoriteBorderRounded from "@mui/icons-material/FavoriteBorderRounded"
import { useEffect, useState } from "react"
import { IconButton } from "@mui/material"

export default function LikeButton({ onToggle, defaultLiked, size = 26 }) {
    const [ hovering, setHovering ] = useState()
    const [ liked, setLiked ] = useState(defaultLiked)
    const HeartIcon = liked ? FavoriteRounded : FavoriteBorderRounded
    const handleToggle = () => {
        setLiked(!liked)
        onToggle && onToggle(!liked)
    }
    return (
        <IconButton 
            onClick={()=>{setHovering(false); handleToggle()}}
            sx={{position: "relative"}}
        >
            <FavoriteRounded sx={{fontSize: size, opacity: hovering ? 0.5 : 0, transition: "opacity 0.3s", position: "absolute"}} color="primary"/>
            <HeartIcon
                onMouseOver={()=>{setHovering(true)}}
                onMouseLeave={()=>{setHovering(false)}}
                sx={{
                fontSize: size, transition: "all 0.3s cubic-bezier(0.175, 0.185, 0.32, 3.5)", 
                position: "absolute", transform: `scale(${hovering ? 1.15 : 1})`}}
                color="primary"
            />
        </IconButton>
    )
}